/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IView, IViewInfo } from "../../../view/IView";

/**
 * View parameters
 */
interface IIframeViewParams {
	url: string;
	label: string;
	icon?: string;
}

/**
 * Iframe View
 */
export class IframeView implements IView<IIframeViewParams> {
	/** Info */
	private label: string;
	private icon: string;
	private url: string;

	/**
	 * View constructor
	 *
	 * @param dc Dependency container
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	public constructor(private dc) {}

	/**
	 * Initializes view
	 * @param params Params
	 */
	public async init(params: IIframeViewParams): Promise<void> {
		this.url = params.url;
		this.label = params.label;
		this.icon = params.icon || "mdi/web";
	}

	/**
	 * Returns iframe URL
	 */
	public getUrl(): string {
		return this.url;
	}

	/**
	 * Dispises view
	 */
	public dispose(): void {
		// Nothing here
	}

	/**
	 * Returns view info
	 */
	public getViewInfo(): IViewInfo {
		return {
			icon: this.icon,
			label: this.label,
			canClose: true,
			isModified: false,
			renderWhenNotActive: true
		};
	}
}
